import React, { useState } from 'react'
import { TabNav } from '../../components/nav/tabNav'
import { PageHeader } from '../../components/typography/PageHeader'
import Layout from '../../layout'
import PremissionsSection from './Permissions'
import RolesSection from './Roles'
import TeamMembers from './TeamMembers'
import { WalletSettings } from './Wallet'
import { SettlementConfiguration } from './settlement'
import GoodInvestors from './GoodInvestors'
import { Origin } from './Origin'
import { DeliveryRegions } from './DeliveryRegions'

const pageTabs = [
  { name: 'Team Members', id: 'Team Members' },
  { name: 'Good Stakeholders', id: 'Good Stakeholders' },
  { name: 'Roles', id: 'Roles' },
  { name: 'Permissions', id: 'Permissions' },
  { name: 'Delivery Regions', id: 'Delivery Regions' },
  { name: 'Wallet', id: 'Wallet' },
  { name: 'Settlement', id: 'Settlement' },
  { name: 'Origin', id: 'Origin' },
]
const Settings: React.FC = () => {
  const [activeTab, setActiveTab] = useState('Team Members')

  return (
    <Layout>
      <PageHeader title="Settings" />

      <TabNav
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        tabs={pageTabs}
        className="mb-10"
      />

      {activeTab === 'Team Members' && <TeamMembers />}
      {activeTab === 'Good Stakeholders' && <GoodInvestors />}
      {activeTab === 'Roles' && <RolesSection />}
      {activeTab === 'Permissions' && <PremissionsSection />}
      {activeTab === 'Delivery Regions' && <DeliveryRegions />}
      {activeTab === 'Wallet' && <WalletSettings />}
      {activeTab === 'Settlement' && <SettlementConfiguration />}
      {activeTab === 'Origin' && <Origin />}
    </Layout>
  )
}

export default Settings
